// extracted by mini-css-extract-plugin
export default {"title":"xba-z","warning":"yba-z","sizeOptionsLegendText":"zba-z"};